<template>
  <div>
    <div class="row mt-3">
      <div class="col-sm-12 col-md-12 col-lg-12">
          <div class="card border-0">
            <div class="card-body p-0">
              <div class="row">
                <div class="col-10 d-flex justify-content-start align-items-center">
                  <ul class="pagination text-smallest">
                    <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
                      <button class="page-link" @click="setPage(1)">First</button>
                    </li>

                    <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
                      <button class="page-link" @click="setPage(page)">{{ page }}</button>
                    </li>

                    <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
                      <button class="page-link" @click="setPage(pagination.lastPage)">Last</button>
                    </li>
                  </ul>
                </div>
                <div class="col-2 d-flex justify-content-end align-items-center">
                  <button v-if="finalizedReports.length" class="ml-2 e-btn force-white-all w-100" @click="exportToExcel" :disabled="loading" :class="loading ? 'e-btn-blue-gray cursor-not-allowed' : 'e-btn-primary'">
                    <font-awesome-icon class="mr-1" icon="download"/>
                    Download
                  </button>
                  <button v-else class="ml-2 e-btn force-white-all w-100 e-btn-blue-gray cursor-not-allowed">
                    <font-awesome-icon class="mr-1" icon="download"/>
                    Download
                  </button>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-3 pr-0">
                  <div class="row">
                    <div class="col pr-0 text-center">
                      <label class="col-form-label font-weight-bold">From Year: </label>
                    </div>
                    <div class="col-8">
                      <select class="form-control form-control-sm text-uppercase" name="year_from" id="year_from" v-model="filters.year_from" @change="getReportsMoreThan24Hrs(filters)" :disabled="loading">
                        <option :value="null">YYYY</option>
                        <template v-for="year in availableFromYears">
                          <option :value="year" :key="'to-' + year">
                            {{ year }}
                          </option>
                        </template>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-3 pr-0">
                  <div class="row">
                    <div class="col pr-0 text-center">
                      <label class="col-form-label font-weight-bold">To Year: </label>
                    </div>
                    <div class="col-9">
                      <select class="form-control form-control-sm text-uppercase" name="year_to" id="year_to" v-model="filters.year_to" @change="getReportsMoreThan24Hrs(filters)" :disabled="loading">
                        <option :value="null">YYYY</option>
                        <template v-for="year in availableToYears">
                          <option :value="year" :key="'to-' + year">
                            {{ year }}
                          </option>
                        </template>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-3 pr-0">
                  <div class="row">
                    <div class="col text-center">
                      <label class="col-form-label font-weight-bold">Filter By: </label>
                    </div>
                    <div class="col-8 pl-0">
                      <select class="form-control form-control-sm text-uppercase" id="fleetList" v-model="filters.fleet_id" :disabled="loading">
                        <option :value="null">ALL FLEET</option>
                        <template v-for="fleet in fleetKeys">
                          <option :value="fleet.id" v-if="fleet?.name !== 'N/A' && fleet.code !== 'N/A'">
                            {{fleet.name ? fleet.name.toUpperCase() : ''}}
                          </option>
                        </template>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="row">
                    <div class="col text-center">
                      <label class="col-form-label font-weight-bold">Event Type 1: </label>
                    </div>
                    <div class="col-6 pl-0">
                      <select class="form-control form-control-sm text-uppercase" v-model="filters.event_type_1" :disabled="loading">
                        <option :value="null">All Event Types</option>
                        <option class="text-uppercase" v-for="event in eventOneKeys" :key="event.id" :value="event.id">
                          {{ event.code }}) {{ event.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
    <div class="row no-gutters text-center mb-3" style="max-height: 75vh; overflow-y: auto">
      <div class="col-12">
        <table class="small e-tbl ">
          <thead class="bg-white" style="position: sticky; top: 0; z-index: 2">
          <tr>
            <th class="align-middle" style="width: 1em" scope="col">#</th>
            <th class="align-middle" scope="col">VESSEL</th>
            <th class="align-middle" scope="col">MANAGER</th>
            <th class="align-middle" scope="col">EVENT CODE 1</th>
            <th class="align-middle" style="min-width: 25em" scope="col">REPORT TITLE</th>
            <th class="align-middle" style="width: 5em" scope="col">STATUS</th>
            <th class="align-middle" style="min-width: 9em" scope="col" @click="sortColumn('event_date')">EVENT DATE
              <font-awesome-icon icon="arrow-down" v-if="filters.direction === 'asc' && filters.order_by === 'event_date'" class="sort-arrow-up"/>
              <font-awesome-icon icon="arrow-up" v-else-if="filters.direction === 'desc' && filters.order_by === 'event_date'" class="sort-arrow-down"/>
              <font-awesome-icon icon="sort" v-else/></th>
            <th class="align-middle" style="min-width: 13em">PLACE</th>
            <th class="align-middle" style="width: 4em" scope="col">EVENT CLASS</th>
            <th class="align-middle" style="min-width: 6em" scope="col" @click="sortColumn('delay_hrs')">DELAY (HRS.)
              <font-awesome-icon icon="arrow-down" v-if="filters.direction === 'asc' && filters.order_by === 'delay_hrs'" class="sort-arrow-up"/>
              <font-awesome-icon icon="arrow-up" v-else-if="filters.direction === 'desc' && filters.order_by === 'delay_hrs'" class="sort-arrow-down"/>
              <font-awesome-icon icon="sort" v-else/>
            </th>
            <th class="align-middle" style="min-width: 20em">ROOT CAUSE</th>
            <th class="align-middle" style="width: 70px" scope="col">ACTION</th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="loading">
            <td colspan="100%">
              <loading></loading>
            </td>
          </tr>
          <template v-else>
            <template v-if = "finalizedReports.length === 0">
              <tr>
                <td colspan="100%" class="text-center py-3">
                  No records found.
                </td>
              </tr>
            </template>
            <template v-else v-for="(report, index) in finalizedReports">
              <tr class="text-uppercase" :key="report.id" :class="[new Date(report.event_date) <= new Date('2000-01-01') ? 'test-data-row' : '' ]">
                <td scope="row">{{ index + pagination.from }}</td>

                <td class="align-middle" style="white-space: nowrap;padding:0">{{ report.vessel }}</td>
                <td class="align-middle" style="white-space: nowrap;padding:0">{{ report.management_office }}</td>
                <td class="align-middle" v-if="report.event.event_one !== null" :class="['bg-' + eventOneColorCode[report.event.event_one.code].color_code]">
                  {{ report.event.event_one.name }}
                </td>
                <td class="align-middle" v-else>
                </td>
                <td class="align-middle">{{ report.title }}</td>
                <td class="align-middle text-white" :class="['bg-'+report.report_status_color]">{{ report.report_status ? report.report_status : 'NEW' }}</td>
                <td class="align-middle">
                  {{ report?.formatted_event_date }}
                </td>
                <td class="align-middle">{{ report.place }}</td>
                <td class="align-middle"
                    :class="{
                                'eventClass_A': report.event_class === 'A',
                                'eventClass_B': report.event_class === 'B',
                                'eventClass_C': report.event_class === 'C'
                              }">
                  {{ report.event_class }}
                </td>
                <td class="align-middle">{{ report.totalDelayHrs }}</td>
                <td class="align-middle">{{ report?.cause?.root_cause?.name }}</td>
                <td class="align-middle text-center">
                  <div class="dropdown dropright my-1">
                    <button
                      id="actionDropdown"
                      aria-expanded="false"
                      aria-haspopup="true"
                      class="btn btn-sm btn-secondary force-white-all"
                      data-toggle="dropdown"
                    >
                      <font-awesome-icon icon="cogs"/>
                    </button>
                    <div aria-labelledby="actionDropdown" class="dropdown-menu py-0">
                      <button class="dropdown-item text-secondary font-weight-bolder"
                              @click="showReport(report.id)"
                      >
                        <font-awesome-icon icon="eye"/>
                        View
                      </button>
                      <button class="dropdown-item text-secondary font-weight-bolder"
                              @click="showReportNewTab(report.id)"
                      >
                        <font-awesome-icon icon="share"/>
                        View on New Tab
                      </button>
                      <button class="dropdown-item text-secondary font-weight-bolder text-danger"
                              @click="deleteSelected(report.id)"
                              v-if="isAllowed('accident-incident.delete') && ((report.report_status_id !== 1 && user.roles_permissions.roles[0] !== 'superintendent' && user.is_vessel === false) || (report.report_status_id === 1 && report.created_by_id == user.id)) "
                      >
                        <font-awesome-icon icon="trash" class="force-danger-all"/>
                        Delete
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </template>
          </tbody>
        </table>
      </div>
    </div>
    <new-accident-incident-report />
    <event-class-help-menu-modal modalId="eventClassDescription"/>
  </div>
</template>

<script>
import NewAccidentIncidentReport from '../layouts/NewAccidentIncidentReport'
import {vueAppMixin} from "@/mixins/vueAppMixin";
import {permissionMixin} from "@/mixins/permissionMixins";
import AppLoading from "@/components/elements/AppLoading";
import { PaginationMixin } from "@/mixins/PaginationMixin";
import {AlertService} from "@/services/AlertService";
import {ReportService} from "@/services/ReportService";
import EventClassHelpMenuModal from "@/components/EventClassHelpMenuModal.vue";
import DatePicker from 'vue2-datepicker';
const {mapGetters,mapActions} = require('vuex')
import en from "vue2-datepicker/locale/es/en";
import {VesselService} from "@/services/VesselService";

export default {
  name: 'ShipsPiAccidentIncidentDelay24Hrs',
  data() {
    return {
      filters: {
        page: 1,
        count: 30,
        fleet_id:null,
        status_id:null,
        office_id:null,
        flag_id:null,
        company_id:null,
        date_from : null,
        date_to   : null,
        event_type_1 : null,
        year_from: null,
        year_to: new Date().getFullYear(),
        direction: 'desc'
      },
      date_range : null,
      exportVesselId: null,
      toExport: false,
      loading: false,
      eventOneColorCode : {
        a : { // 1
          color      : '#0000ff',
          color_code : '0000ff'
        },
        b : { // 2
          color      : '#0000ff',
          color_code : '0000ff'
        },
        c : { // 3
          color      : '#ff0000',
          color_code : 'ff0000'
        },
        d : { // 4
          color      : '#ffbf00',
          color_code : 'ffbf00'
        },
        e : { // 5
          color      : '#c75912',
          color_code : 'c75912'
        },
        f : { // 6
          color      : '#c75912',
          color_code : 'c75912'
        },
        g : { // 7
          color      : '#7030a0',
          color_code : '7030a0'
        },
        h : { // 8
          color      : '#7030a0',
          color_code : '7030a0'
        },
        i : { // 9
          color      : '#548235',
          color_code : '548235'
        },
        j : { // 10
          color      : '#ff0066',
          color_code : 'ff0066'
        },
        k : { // 11
          color      : '#2f5496',
          color_code : '2f5496'
        },
        l : { // 12
          color      : '#2f5496',
          color_code : '2f5496'
        },
        m : { // 13
          color      : '#a6a6a6',
          color_code : 'a6a6a6'
        }
      }
    }
  },
  components: {
    'event-class-help-menu-modal': EventClassHelpMenuModal,
    'new-accident-incident-report': NewAccidentIncidentReport,
    'loading': AppLoading,
    DatePicker
  },
  mixins:[vueAppMixin,permissionMixin, PaginationMixin],
  methods: {
    ...mapActions([ 'getEventOneKeys','deleteReport','getReportsMoreThan24Hrs', 'getVesselKeys','getFleetListKeys','getReportStatus','getCountryListKeys','getMngmtOfficeKeys','getManagementCompanyKeys', 'downloadAccidentIncidentStatusHistory']),
    async showReport (reportId) {
      await this.$router.push(
        {
          name: 'AccidentIncidentReport',
          params: {
            id: reportId,
          },
        },

      ).catch(() => {})
    },
    async showReportNewTab (reportId) {
      const route= this.$router.resolve(
        {
          name: 'AccidentIncidentReport',
          params: {
            id: reportId,
          },
        },
      )
      window.open(route.href,'_blank')
    },

    async sortColumn(column){
      if(this.filters.direction === ''){
        this.filters.direction = 'asc';
      }
      else if(this.filters.direction === 'asc'){
        this.filters.direction = 'desc';
      }
      else{
        this.filters.direction = 'asc';
      }

      this.filters.order_by = column;

      var column_title = null;
      if(column === 'delay_hrs'){
        column_title = 'Delay Hours';
      }
      else {
        column_title = 'Event Date';
      }

      swal.fire({
        'title': 'Sorting Columns by '+column_title,
        text: 'Please wait...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      });
      swal.showLoading();
      await this.getReportsMoreThan24Hrs(this.filters)
      swal.close();
    },

    async deleteSelected(reportId){
      if(await this.confirmDeleteAlert()){
        swal.fire({
          title:'ENTER YOUR PASSWORD',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off'
          },
          confirmButtonText:'PROCEED DELETION',
          cancelButtonText: 'CANCEL',
          showCancelButton:true,
          allowOutsideClick:false,
          allowEscapeKey:false,
          allowEnterKey:false,
          confirmButtonColor:'#dc3545',
          showLoaderOnConfirm:true,
          preConfirm:async (inputValue)=> {
            let response = await this.deleteReport({reportId: reportId, password: inputValue});
            if (typeof response === 'boolean' && response) {
              return response;
            } else {
              if (response.hasOwnProperty('message') && !response.hasOwnProperty('errors')) {
                swal.showValidationMessage(response.message);
              }
              else{
                swal.showValidationMessage(response.errors.password.join(','));
              }
            }
          }
        })
          .then(async (result)=>{
            if(result.isConfirmed){
              this.successAlert('Report Deleted Successfully','DELETE ACCIDENT/INCIDENT REPORT');
            }
          });
        // let response = await this.deleteReport(reportId);
        //  if(response) this.successAlert('Report Deleted Successfully','DELETE ACCIDENT/INCIDENT REPORT');
      }
    },

    async exportToExcel(){
      swal.fire({
        'title': `LOADING...`,
        text: 'Please wait while the system exports the data.',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      })
      swal.showLoading()
      const downloadResponse = await ReportService.downloadReportMoreThan24Hrs(this.filters);
      swal.close()
      let url = window.URL.createObjectURL(new Blob([downloadResponse.data],{type:'application/vnd.ms-excel'}))
      let filename=`Accident_Incident_DelayHrs_24H_${Date.now()}.xlsx`;
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    },

    setPage(page) {
      localStorage.setItem('accidentIncidentPage',page)
      this.pagination.currentPage = page;
      this.filters.page = page
      this.getReportsMoreThan24Hrs(this.filters)
    },
    initializeWatcher(){
      this.$watch(()=>this.$route.query,async (present,previous)=>{
        this.filters.page=1
        this.filters.search=present?.search
        await this.getReportsMoreThan24Hrs(this.filters)
      });
    },
  },
  async created() {
    this.loading = true
    await this.getVesselKeys()
    this.initializeWatcher()
    this.filters.page=1;
    if(this.$route.query.search){
      this.filters.search=this.$route.query.search
    }
    await this.getFleetListKeys();
    await this.getReportStatus();
    await this.getMngmtOfficeKeys();
    await this.getCountryListKeys();
    await this.getManagementCompanyKeys();
    await this.getEventOneKeys()
    await this.getReportsMoreThan24Hrs(this.filters)
    this.loading = false
  },
  computed: {
    ...mapGetters(['reports','reportsMoreThan24Hrs','eventOneKeys','isLoading', 'vesselKeys','fleetKeys','mngmntOfficeKeys','countryKeys','reportStatusKeys','mngmtCompanyKeys']),
    finalizedReports() {
      let newReports = [];
      this.reportsMoreThan24Hrs.forEach((report) => {
        let newReportCondition = (report.report_status_id === 1) && (this.user.roles_permissions.roles[0] !== 'instructor' || (this.user.roles_permissions.roles[0] === 'instructor' && report.is_confidential_report === true));
        let otherReportCondition = report.report_status_id !== 1;

        if (newReportCondition === true || otherReportCondition) {
          newReports.push(report);
        }
      });
      return newReports;
    },
    allPossibleYears() {
      const currentYear = new Date().getFullYear();
      const startYear = 2015;
      const yearArray = [];

      for (let year = startYear; year <= currentYear; year++) {
        yearArray.push(year);
      }
      return yearArray;
    },
    availableFromYears() {
      return this.allPossibleYears.filter(year => year <= this.filters.year_to);
    },
    availableToYears() {
      return this.allPossibleYears.filter(year => year >= this.filters.year_from);
    },
    en() {
      return en
    },
  },
  watch: {
    async 'filters.count'(count) {
      this.filters.count = count
      this.filters.page = 1
      this.loading = true
      await this.getReportsMoreThan24Hrs(this.filters)
      this.loading = false
    },
    async 'filters.flag_id'(flag_id) {
      this.filters.flag_id = flag_id
      this.filters.page = 1
      this.loading = true
      await this.getReportsMoreThan24Hrs(this.filters)
      this.loading = false
    },
    async 'filters.fleet_id'(fleet_id) {
      this.filters.fleet_id = fleet_id
      this.filters.page = 1
      this.loading = true
      await this.getReportsMoreThan24Hrs(this.filters)
      this.loading = false
    },
    async 'filters.office_id'(office_id) {
      this.filters.office_id = office_id
      this.filters.page = 1
      this.loading = true
      await this.getReportsMoreThan24Hrs(this.filters)
      this.loading = false
    },
    async 'filters.status_id'(status_id) {
      this.filters.status_id = status_id
      this.filters.page = 1
      this.loading = true
      await this.getReportsMoreThan24Hrs(this.filters)
      this.loading = false
    },
    async 'filters.company_id'(company_id) {
      this.filters.company_id = company_id
      this.filters.page = 1
      this.loading = true
      await this.getReportsMoreThan24Hrs(this.filters)
      this.loading = false
    },
    async 'filters.event_type_1'(event_type_1) {
      this.filters.event_type_1 = event_type_1
      this.filters.page = 1
      this.loading = true
      await this.getReportsMoreThan24Hrs(this.filters)
      this.loading = false
    },
    'filters.year_from'(newVal) {
      if (newVal > this.filters.year_to && newVal !== null) {
        this.filters.year_to = newVal;
      }
    },
    'filters.year_to'(newVal) {
      if (newVal < this.filters.year_from && newVal !== null) {
        this.filters.year_from = newVal;
      }
    },
    async 'date_range'() {
      this.loading = true;
      this.filters.date_from = this.date_range[0]
      this.filters.date_to = this.date_range[1]
      await this.getReportsMoreThan24Hrs(this.filters)
      this.loading = false;
    }
  }
}
</script>

<style scoped>
table tr td{
  font-size: 10px;
}
</style>
